const QUICK_LINKS_RANGE = ['1.0', '1.2', '1.4', '1.6', '1.8', '2.0', '2.4', '2.6', '3.0'];

export { QUICK_LINKS_RANGE };
